import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as RightArrow } from "../../../assets/Icons/rightArrow.svg";
import ShowCard from "../../../Components/ShowCard/ShowCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { Link, useNavigate } from "react-router-dom";
import { useWindowWidth } from "@react-hook/window-size";
import { useSelector } from "react-redux";
import MagazineCard from "../../../Components/MagazineCard/MagazineCard";
import ShortsCard from "../../../Screens/Shorts/ShortsCard";
import Translate from "../../../Components/Multilanguage/Translate";
import { navigateToCategory, rowItemCount, translateText } from "../../../utils/utils";
import { useTranslation } from "react-i18next";

const Categories = ({ data, overlapBanner,onRemoveItem }) => {
  const { t } = useTranslation();
  const languageModal = useSelector((state) => state?.languageModal?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const windowSize = useWindowWidth();
  const navId = useRef(`cat-${Math.random().toString(36).slice(2)}`);
  const [rowItemCountNumber, setRowItemCountNumber] = useState(5);
  const enableCustomRowCount = true;
  const visibleItemsCount = (enableCustomRowCount && data?.visible_items_count) ? Math.ceil(Number(data.visible_items_count)) : null;
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const count = data?.shows?.length;
  const theme =projectInfo?.projectConfig?.config?.THEME ;
  const [displayedData, setDisplayedData] = useState(data?.shows || []);
  const effectiveCount = (enableCustomRowCount ? visibleItemsCount : null) ?? projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT;
  const portraitDefault = 7;
  const portraitSlides = effectiveCount ?? portraitDefault;
  const isKids = template === 'TEMPLATE_12';

    useEffect(() => {
      if (windowSize > 1200){
        if (data?.type === 'SHORTS'){
          const baseCount = projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT || 5;
          setRowItemCountNumber(baseCount + 1);
        }
      }
      if (windowSize > 980) {
      const configCount = (enableCustomRowCount ? visibleItemsCount : null) ?? projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT;
      const newClass = configCount
        ? rowItemCount(configCount)
        : "rowCount5";
      setRowItemCountNumber(parseInt(newClass.replace(/\D/g, ''), 10));
          if (data?.type === 'FASTCHANNELS'){
            setRowItemCountNumber(9);
          }
          if (data?.type === 'SHORTS'){
            const baseCount = projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT || 4;
            setRowItemCountNumber(baseCount + 1);
          }
        } else {
          if (windowSize > 767){
            setRowItemCountNumber(3);
          } else if (windowSize > 479){
            setRowItemCountNumber(2);
          } else if (windowSize > 319){
            setRowItemCountNumber(1);
          }
          if (data?.type === 'FASTCHANNELS'){
            if (windowSize > 767){
              setRowItemCountNumber(4);
            } else if (windowSize > 319){
              setRowItemCountNumber(3);
            }
          }
        }
      if (data?.type === 'FASTCHANNELS'){
        if (windowSize > 767){
          setRowItemCountNumber(4);
        } else if (windowSize > 319){
          setRowItemCountNumber(3);
        }
      }
    }, [projectInfo, windowSize]);

     
  if (isRTL && count > rowItemCountNumber) {
    displayedData = [...data?.shows].reverse();
  }

  const navigate = useNavigate();
  const thumbnailOrientation = data?.thumbnail_orientation ? data?.thumbnail_orientation : projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION;

  const handleRemoveItem = (videoIdToRemove) => {
    setDisplayedData(prevData => {
        const updated = prevData.filter(item => item.video_id !== videoIdToRemove );
        if (onRemoveItem) {
          onRemoveItem(data?.id || data?.category_name, videoIdToRemove);
        }

        return updated;
      });
  };
  return (
    <div className={`categoriesContainer ${isRTL ? (count > rowItemCountNumber ? "ltr" : windowSize < 980 ? "rtl" : "rtl" ) : ""} ${(projectInfo?.projectConfig?.pubid === 50167) ? "netflix" : ""} ${template === 'TEMPLATE_12' ? 'kids' : ''}` + (overlapBanner ? " overlap-banner" : "")}
      role="region"
      aria-label="Categories Section">
      <div className="wrapper">
        <div
          className={`categoryNameContainer ${data?.show_all_needed ? 'link' : ''}`}
          onClick={data?.show_all_needed ? () => navigateToCategory(navigate, data, thumbnailOrientation) : undefined}
          role={data?.show_all_needed ? "button" : undefined}
          tabIndex={data?.show_all_needed ? 0 : undefined}
          aria-label={data?.show_all_needed ? `View all ${data?.category_name}` : undefined}
          onKeyDown={data?.show_all_needed ? (e => { if (e.key === 'Enter' || e.key === ' ') navigateToCategory(navigate, data, thumbnailOrientation); }) : undefined}
        >
          <h1>{data?.category_name}</h1>
          { data?.show_all_needed && ((template == 'TEMPLATE_9' || template === "TEMPLATE_12") ? <span> {translateText(languageModal, t, 'show_all')}</span> : <RightArrow />)}
        </div>
        <div className="itemsContainer">
          <div className={isKids ? 'kids-swiper-nav-wrapper' : ''}>
          <Swiper
            key={isRTL ? (count > rowItemCountNumber ? "ltr" : windowSize < 980 ? "rtl" : "rtl" ) : ""}
            modules={[Navigation]}
            spaceBetween={10}
            slidesPerView={6}
            navigation={isKids ? {
              prevEl: `#${navId.current}-prev`,
              nextEl: `#${navId.current}-next`,
            } : true}
            watchSlidesProgress
            loop={false}
            initialSlide={(isRTL && count > rowItemCountNumber) ? count - 1 : 0}
            className={`${thumbnailOrientation === "PORTRAIT" ? "portrait" : "landscape"} ${theme === "LIGHT" ? "white-bg" : ""}`}
            breakpoints={{
              320: {
                slidesPerView: thumbnailOrientation === "PORTRAIT" ? 2 : data?.type == 'FASTCHANNELS' ? 3 : 1,
                spaceBetween: 5,
              },
              480: {
                slidesPerView: thumbnailOrientation === "PORTRAIT" ? 3 : data?.type == 'FASTCHANNELS' ? 3 : 2,
                spaceBetween: 5,
              },
              768: {
                slidesPerView: thumbnailOrientation === "PORTRAIT" ? 4 : data?.type == 'FASTCHANNELS' ? 4 : 2,
                spaceBetween: 10,
              },
              980: {
                slidesPerView: data?.type === 'SHORTS'
                  ? (projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT ? Number(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT) + 1 : 5)
                  : data?.type == 'FASTCHANNELS'
                    ? 9
                    : thumbnailOrientation === 'PORTRAIT'
                      ? 4
                      : (effectiveCount ?? 4),
                spaceBetween: 10,
              },
              1200: {
                slidesPerView: data?.type === 'SHORTS'
                  ? (projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT ? Number(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT) + 1 : 6)
                  : data?.type == 'FASTCHANNELS'
                    ? 9
                    : thumbnailOrientation === 'PORTRAIT'
                      ? portraitSlides
                      : (effectiveCount ?? 5),
                spaceBetween: data?.type === 'SHORTS' ? 10 : 20,
              },
            }}
            aria-label="Categories Carousel"
          >
            {displayedData?.map((item, index) => (
              <SwiperSlide key={index} aria-label={`Category Slide ${index + 1}`}> 
                <div className={data?.type === "SHORTS" ? "shortsCardContainer" : "show"}>

                  {
                    data?.type === "MAGAZINES" ? (
                      <MagazineCard
                        data={item}
                        url={data.url}
                        metaData={true}
                        cardHover={true}
                      />
                    ) : data?.type === "SHORTS" ? (
                      <ShortsCard
                        data={item}
                        season={false}
                        metaData={true}
                        type={data?.type}
                        vanityUrl={item?.vanity_url}
                      />
                    ) : (
                      <ShowCard
                        data={item}
                        season={false}
                        metaData={true}
                        type={data?.type}
                        thumbnailOrientation={thumbnailOrientation}
                        displayedData={displayedData}
                        onRemove={handleRemoveItem}
                      />
                    )
                  }

                </div>

              </SwiperSlide>
            ))}
          </Swiper>
          {isKids && (
            <>
              <div id={`${navId.current}-next`} className="swiper-button-next" />
              <div id={`${navId.current}-prev`} className="swiper-button-prev" />
            </>
          )}
          </div>
          </div>
      </div>
    </div>
  );
};

export default Categories;
